import { render } from "./HouseIcon.vue?vue&type=template&id=2c012efa"
import script from "./HouseIcon.vue?vue&type=script&lang=js"
export * from "./HouseIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__